function setCoachAccess(data){
    return{
        type : "SET_COACH_ACCESS",
        payload : data
    }
}

export {setCoachAccess};